resolverMap